/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import OtherCharges from "./OtherCharges.container";

export default OtherCharges;
